import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';

export default function PublicRoute({ children }) {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired
};
